import useFeatureFlags, { FEATURE_FLAGS } from "./use-feature-flags";

interface UseOriQaEnabledReturn {
  enabled: boolean;
  loading: boolean;
}

// Gates the Ori QA testing tools (connect a coach configuration to an isolated
// test chat). Kept separate from the `ori` product entitlement so QA
// access is granted independently — a stakeholder testing configs does not
// need the product rolled out to them.
export default function useOriQaEnabled(): UseOriQaEnabledReturn {
  const { isEnabled, loading } = useFeatureFlags();

  return {
    enabled: isEnabled(FEATURE_FLAGS.ORI_QA),
    loading,
  };
}
